import { Injectable } from '@angular/core';
import { AccountCriteria } from '../account-list/_models/account-criteria';
import { Observable, Subject } from 'rxjs';
import { HttpResponse, HttpClient } from '@angular/common/http';
import { API_URL, ENDORSEMENT_URL } from 'src/app/_common/constants';
import { map } from 'rxjs/operators';
import { CommonService } from 'src/app/_services/common.service';
import { PolicyListByAccountCriteria } from '../policy-list-by-account/_models/policy-list-by-account-criteria';
import { PolicyService } from 'src/app/_services/policy.service';
import { FileDownloadService } from 'src/app/_services/file-download.service';
import { ModalService } from 'src/app/_services/modal.service';
import { Modules } from 'src/app/_common/_enum/module.enum';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(private http: HttpClient, private commonService: CommonService, private policyService: PolicyService, private fileDownloadService: FileDownloadService, private modalService: ModalService) { }
  
  set header(data){
    this.commonService.header = data;
  }
  
  get runningServices(){
    return this.commonService.runningServices;
  }

  storeAccountData(account){
    let psiData = this.commonService.getData();
    psiData.selectedAccount = account;
    this.commonService.storeData(psiData);
  }
  
  getAccountData(){
    let psiData = this.commonService.getData();
    return psiData.selectedAccount;
  }

  storePolicyData(policy){
    let psiData = this.commonService.getData();
    psiData.selectedPolicy = policy;
    this.commonService.storeData(psiData);
  }

  getPolicyData(){
    let psiData = this.commonService.getData();
    return psiData.selectedPolicy;
  }

  fetchAccounts(criteria: AccountCriteria):Observable<HttpResponse<any>> {
    return this.http.post<any>(API_URL.Accounts, criteria, {observe: 'response'})
        .pipe(map(accounts => {
            return accounts.body.result;
        }));
  }

  // Fetching Policies by Account from the PolicyListService.
  fetchPoliciesByAccount(filters: PolicyListByAccountCriteria):Observable<HttpResponse<any>> {
    return this.policyService.fetchPoliciesByAccount(filters);
  }

  // Fetching Account by Account Number from the fetchPoliciesByAccount.
  fetchAccountByAccountNumber(filters: PolicyListByAccountCriteria):Observable<HttpResponse<any>> {
    return this.fetchPoliciesByAccount(filters);
  }

  fetchBillingAccountHeader(accountNumber):Observable<HttpResponse<any>> {
    return this.http.get<any>(API_URL.BillingHeader + "/"+ accountNumber, {observe: 'response'})
        .pipe(map(data => {
            return data.body.result;
        }));
  }
  fetchBillingAccountData(accountNumber):Observable<HttpResponse<any>> {
    return this.http.get<any>(API_URL.BillingData + "/"+ accountNumber, {observe: 'response'})
        .pipe(map(data => {
            return data.body.result;
        }));
  }
  fetchDirectBillPoliciesByAccount(accountNumber: string):Observable<HttpResponse<any>> {
    return this.http.get<any>(API_URL.Accounts + "?accountNumber="+ accountNumber, {observe: 'response'})
        .pipe(map(policies => {
            return policies;
        }));
  }

  fetchInstallmentSchedulesByAccount(accountNumber: string):Observable<HttpResponse<any>> {
    return this.http.get<any>(API_URL.InstallmentSchedules + "?accountNumber="+ accountNumber, {observe: 'response'})
        .pipe(map(policies => {
            return policies.body.result;
        }));
  }

  fetchMonthlyReporterByAccount(accountNumber: string):Observable<HttpResponse<any>> {
    return this.http.get<any>(API_URL.MonthlyReporter + "/"+ accountNumber, {observe: 'response'})
        .pipe(map(response => {
            return response.body.result;
        }));
  }

  fetchPaymentsByAccount(accountNumber: string):Observable<HttpResponse<any>> {
    return this.http.get<any>(API_URL.Payment + "/"+ accountNumber, {observe: 'response'})
        .pipe(map(policies => {
            return policies.body.result;
        }));
  }

  fetchAccountActivity(accountNumber: string):Observable<HttpResponse<any>> {
    return this.http.get<any>(API_URL.ViewActivity + "?accountNumber="+ accountNumber, {observe: 'response'})
        .pipe(map(accounts => {
            return accounts.body.result;
        }));
  }
  
  fetchPolicyActivity(policyNumber: string):Observable<HttpResponse<any>> {
    return this.http.get<any>(API_URL.ViewActivity + "?policyNumber="+ policyNumber, {observe: 'response'})
        .pipe(map(accounts => {
            return accounts.body.result;
        }));
  }

  downloadInvoice(accountNumber: string, invoiceNumber: string):any {
    return this.fileDownloadService.downloadInvoice(accountNumber, invoiceNumber);
  }

  fetchNoticeList(accountNumber: string, policyNumber: string) {
    return this.http.post<any>(API_URL.ViewNotices, { "accountNumber": accountNumber, "policyNumber": policyNumber }, {observe: 'response'})
          .pipe(map(response => {
              return response.body.result;
          }));
  }

  downloadNotice(notice: string, accountNumber: string):any {
    return this.fileDownloadService.downloadNotice(notice, accountNumber);
  }  

  downloadLossRunReport(number: string, reportBy: string):any {
    return this.fileDownloadService.downloadLossRunReport(number, reportBy);
  }

  downloadMRDcouments(accountNumber: string, documentid: string):any {
    return this.fileDownloadService.downloadBillingDocuments(accountNumber, documentid);
  }

  openModal(modalType, modalName) {
    if(modalType === 'error'){
      this.modalService.openErrorModal();
    } else {
      this.modalService.openModal(modalName);
    }
  } 

  closeModal() {
    this.modalService.closeModal();
  }

  hasOpenModals() {
    return this.modalService.hasOpenModals();
  }

  /* Endorsement */
  /* isAccountEndorsementsTabAvailable(){
    let accountData = this.getAccountData();

    return accountData.isAccountEndosements;
  } */

  setAccountEndorsementTab(_isVisible = null){
    let accountData = this.getAccountData();
    accountData.isAccountEndosements = _isVisible;

    this.storeAccountData(accountData);
  }

  fetchEndorsements(number){
    return this.http.get<any>(ENDORSEMENT_URL.Endorsements+"?accountNumber="+number, {observe: 'response'})
        .pipe(map(endorsements => {
            return endorsements.body.result;
        }));
  }
  
  endtTabFlag(selectedAccount:any): Observable<boolean>{
    let endtFlag = new Subject<boolean>();
    if(selectedAccount.accountEndorsementsTab == true || selectedAccount.accountEndorsementsTab === false){
      endtFlag.next(selectedAccount.accountEndorsementsTab);
    } else{
      if(this.commonService.checkPermission(Modules.AccountEndtView)){
        this.fetchEndorsements(selectedAccount.accountNumber).subscribe(endorsements=>{
          if(!endorsements.endorsementsTasks || endorsements.endorsementsTasks.length == 0){
            selectedAccount.accountEndorsementsTab = false;
          }else{
            selectedAccount.accountEndorsementsTab= true;
          }
          this.storeAccountData(selectedAccount);
          endtFlag.next(selectedAccount.accountEndorsementsTab);
        },error=>{
          selectedAccount.accountEndorsementsTab = false;
        }
        );
      }else{
        selectedAccount.accountEndorsementsTab = false;
        endtFlag.next(false);
        this.storeAccountData(selectedAccount);
      }
    }
    return endtFlag.asObservable();
  }

  /**
   * Used for MR policy to display Net Rates if there is open or missed reporting period
   * Query Params :: policyNumber, periodStart, periodEnd, lobName
  **/
  fetchPolicyNetRates(_policyDetails: any):Observable<HttpResponse<any>> {    
    return this.http.post<any>(API_URL.PolicyReportingPeriod, _policyDetails, {observe: 'response'})
        .pipe(map(response => {
            return response.body.result;
        }));
  }

  /**
   * Used to get monthly exposure for MR policy for report completed month
   * Query Params :: accountNumber, reportingStartDate, reportingEndDate
  **/
  fetchMonthlyExposure(_reportDetails: any):Observable<HttpResponse<any>> {
    return this.http.get<any>(API_URL.BillingMonthlyExposure + "?accountNumber="+ _reportDetails.accountNumber +"&reportingStartDate="+ _reportDetails.startDate +"&reportingEndDate="+ _reportDetails.endDate, {observe: 'response'})
        .pipe(map(response => {
            return response.body.result;
    }));
  }

  /**
   * Used to fetch the policy document list
   * @param request - contains the account number, policy numbers [], years [], documentTypes []
   * @returns list of policy documents
   */
  fetchPolicyDocumentList(request) {
    return this.commonService.fetchPolicyDocumentList(request);
  }

  /**
   * Used to download the policy document
   * @param request - account id, documentid
   * @returns bytearray along with header data.
   */
  downloadPolicyDocument(accountId, documentId, documentName ="") {
    return this.fileDownloadService.downloadPolicyDocument(accountId, documentId, documentName);
  }
}